import React from "react";

import './location.css';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import { Button } from "react-bootstrap";

function MapContainer() {
    return (
        <>
            <div id="loc" className="gx-0"> 
                <Map 
                    google={window.google}
                    style={{ width: '100%', height: '100%'}}
                    zoom={19}
                    initialCenter={{
                        lat: -6.169622,
                        lng: 106.917476
                    }}>
                    <Marker />
                </Map>
            </div>
            <div id="open">
                <h6 style={{ marginTop: '7px' }}>Get directions on</h6>  
                <Button id="tombol" href="https://www.google.com/maps/place/ASCO+MOTOR/@-6.1692722,106.916726,17.61z/data=!4m5!3m4!1s0x2e698acc3fe86a4d:0xc905c57b7366d8e6!8m2!3d-6.169749!4d106.9174755">
                    Google Maps
                </Button>
            </div>
        </>
    )
};

export default GoogleApiWrapper({
    apiKey: ('AIzaSyBRvWsYwhrB6qoHE6BkVcGIqqnP5p1mr8A')
})(MapContainer)